import React from 'react';
import { useParams, useHistory } from 'react-router';
import { Button, Result, Space, message } from 'antd';
import { useQuery, useMutation } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import {
  GET_PROJECT_APPLICATION,
  BRING_PROJECT_APPLICATION_TO_PROJECTS,
} from 'gql/projectApplications';
import { GET_PROJECTS } from 'gql/projects';
import { DateDisplay, Link } from 'components/layout';
import { PrivateComponent } from 'components/auth';
import { SCOPE_TYPES } from 'constants/scopes';
import ApplicationDetail from './ApplicationDetail';
import EndorsementSection from './EndorsementSection';
import BringProjectApplicationModal from './BringProjectApplicationModal';

const getStatus = (status) => {
  switch (status) {
    case 'APPROVED':
      return 'success';
    case 'REJECTED':
      return 'error';
    case 'VOIDED':
      return 'warning';
    case 'OVERDUE':
      return 'warning';
    case 'WITHDRAWN':
      return 'warning';
    default:
      return '404';
  }
};
const getTitle = (status) => {
  switch (status) {
    case 'APPROVED':
      return 'Application Endorsed and Received';
    case 'REJECTED':
      return 'Application Rejected';
    case 'VOIDED':
      return 'Application Voided';
    case 'OVERDUE':
      return 'Application Overdue';
    case 'WITHDRAWN':
      return 'Application Withdrawn';
    default:
      return '404';
  }
};
const getSubTitle = (projectApplication) => {
  const deadline = projectApplication?.setting?.endDate;
  switch (projectApplication?.status) {
    case 'OVERDUE':
      return (
        <>
          The deadling of application is <DateDisplay date={deadline} />
        </>
      );
    default:
      return null;
  }
};

const ResultProjectApplication = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION, {
    variables: {
      id: id,
    },
  });
  const history = useHistory();

  const [bringPorjectApplication] = useMutation(
    BRING_PROJECT_APPLICATION_TO_PROJECTS,
    {
      refetchQueries: [{ query: GET_PROJECTS, variables: { status: 'ALL' } }],
      onCompleted: ({ bringProjectApplicationToProjects }) => {
        message.success(`Project application is brought to projects`);
        history.push(
          `/projects/${bringProjectApplicationToProjects.id}/profile`
        );
      },
    }
  );

  const projectApplication = data?.projectApplication;
  const onFinish = async (value) => {
    await bringPorjectApplication({
      variables: {
        input: {
          id,
          title: value.title,
          projectCategory: value.projectCategory,
        },
      },
    });
  };
  const initialValues = {
    title: projectApplication?.title,
  };

  return (
    <>
      <Space size={24}>
        <PrivateComponent
          expectedScopeType={[SCOPE_TYPES.WRITE_PROJECT_APPLICATION]}
        >
          <Link to={`/project-applications/${id}/edit`}>
            <Button type="primary" style={{ marginTop: '16px' }}>
              Edit Application
            </Button>
          </Link>
        </PrivateComponent>
        <PrivateComponent expectedScopeType={[SCOPE_TYPES.WRITE_PROJECT]}>
          <BringProjectApplicationModal
            onFinish={onFinish}
            initialValues={initialValues}
          />
        </PrivateComponent>
      </Space>
      <PageContainer>
        <Result
          status={getStatus(projectApplication?.status)}
          title={getTitle(projectApplication?.status)}
          subTitle={getSubTitle(projectApplication)}
          // extra={getExtra(projectApplication)}
        >
          <ApplicationDetail data={projectApplication} loading={loading} />
          <EndorsementSection
            data={projectApplication?.currentEndorsement}
            loading={loading}
            isResult={true}
          />
        </Result>
      </PageContainer>
    </>
  );
};

export default ResultProjectApplication;
